<template>
    <div class="container">
        <router-view></router-view>
    </div>

</template>
<script>
import Logo from './../home/Logo'
export default {
  name: 'base-template',
  components: {
    logo: Logo
  }
}
</script>
<style>
.hello {
    max-width: 55em;
}
[v-cloak] {
    display: none;
}
</style>



// WEBPACK FOOTER //
// BaseTemplate.vue?58cd3fdb